var map = {
	"./ARB.png": "38fc",
	"./AVAX.png": "126e",
	"./BSC.png": "7c82",
	"./BTC.png": "6c3a",
	"./Base.png": "90d2",
	"./CFX.png": "3e42",
	"./DOGE.png": "cec4",
	"./DOT.png": "de2c",
	"./EOS EVM.png": "c6bd",
	"./EOS.png": "6630",
	"./ETC.png": "d5ee",
	"./ETH.png": "ceac",
	"./ETHW.png": "981f",
	"./FTM.png": "1b4f",
	"./GLMR.png": "78ca",
	"./HECO.png": "ca68",
	"./IOST.png": "932f",
	"./KCC.png": "43f5",
	"./KLAY.png": "aa9a",
	"./KSM.png": "f50b",
	"./LINEA.png": "a453",
	"./MATIC.png": "e9b0",
	"./Mantle.png": "b678",
	"./OEC.png": "6e9f",
	"./OKTC.png": "8a56",
	"./OP.png": "6559",
	"./OPBNB.png": "631f",
	"./SOL.png": "dba1",
	"./TRX.png": "b1ee",
	"./ZVM.png": "7207",
	"./aptos.png": "5d77",
	"./delete-dark.png": "0b51",
	"./delete.png": "19d7",
	"./rexiao.png": "ec15",
	"./search-back-dark.png": "d3cd",
	"./search-back.png": "92f5",
	"./search-empty.png": "3282",
	"./search-empty_dark.png": "c780",
	"./search-loading.png": "e1c4",
	"./search-loading_dark.png": "a39f",
	"./search.png": "d887",
	"./swap-token-search.png": "2289",
	"./swap-token-search_dark.png": "061e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b06";